<template>
  <div class="attchment-for-tenant">
    <div
      id="attachments"
      class="attachments"
    >
      <div class="title">{{ $t('handover.attachmentsForTenant') }}</div>
      <HkldDropzone
        v-if="allowEdit"
        :sourceId="pubDocResourceId"
      />
      <EditAttachments
        ref="editAttachments"
        :sourceId="pubDocResourceId"
        :canEdit="allowEdit"
        :canDelete="allowEdit"
        :canDownloadAll="false"
        :getFilesList="getFilesList"
      />
      <div v-show="isWappr && isEmpty">--</div>
    </div>
  </div>
</template>

<script>
import HkldDropzone from '@/controls/HkldDropzone'
import EditAttachments from '@/controls/EditAttachments'
import { mapGetters, mapMutations } from 'vuex'
import mutationTypes from '@/store/mutation-types'
import lodash from 'lodash'

export default {
  name: 'AttchmentForTenant',
  components: {
    HkldDropzone,
    EditAttachments,
  },
  props: {
    allowEdit: {
      type: Boolean,
      default: false,
    },
    isWappr: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isEmpty: false,
    }
  },
  methods: {
    ...mapMutations('hotb', {
      updateFieldByPath: mutationTypes.HOTB_UPDATE_FIELD_PATH,
    }),
    getFilesList (list) {
      this.updateFieldByPath({path: ['docsToTenant'], newValue: lodash.cloneDeep(list)})
    },

    async forceLoadAttachments () {
      await this.$refs.editAttachments.loadFiles()
    },
  },
  computed: {
    ...mapGetters('hotb', ['currentHotb']),
    pubDocResourceId () {
      return this.currentHotb.pubDocResourceId || ''
    },
  },
  mounted () {
    this.$on('controls.hkldDropzone.loadFilesLength', (filesCount) => {
      this.isEmpty = !filesCount
    })
  },
}
</script>

<style lang="scss">
.attchment-for-tenant {
  #attachments .title{
    font-weight: bold;
    margin-bottom: 15px
  }
}
</style>
